//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="newTaskBoardOnClick">Создать новую доску</Button>

    <el-tabs v-if="commonData.isLoaded == true" tab-position="left" style222222222222="height:calc(100% - 50px);">
      <el-tab-pane v-for="(item, key) in commonData.taskBoards" :key="key" style="">
        <span slot="label">
          <div class="board-title">
            <span>{{item.val.name}}</span>
            <span v-on:click="editTaskBoardSettingsOnClick(item)"><Icon type="android-settings" class="board-edit-icon"></Icon></span>
          </div>
        </span>

        <task-board :board="item.val">
        </task-board>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import TaskBoard from '@/components/Tasks/TaskBoard'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  // data () {
  //   return {
  //     some: null
  //   }
  // },
  components: { TaskBoard },
  computed: {
    ...mapGetters([
      'commonData',
      'appSettings'
    ])
  },
  methods: {
    ...mapMutations([
      'commonDataTaskBoardsAdd',
      'commonDataTaskBoardForChangeSettingsSet'
    ]),
    newTaskBoardOnClick () {
      let thisRef = this
      let newTaskBoard = restResource(this.appSettings.server.host + this.appSettings.server.taskBoardsResource)
      newTaskBoard.val = {
        name: 'Новая доска',
        deleted: 0
      }
      newTaskBoard.save()
      .then(function (response) {
        newTaskBoard.val = response.data
        // thisRef.$message.success('Запись сохранена на сервер')
        thisRef.commonDataTaskBoardsAdd(newTaskBoard)
        thisRef.commonDataTaskBoardForChangeSettingsSet(newTaskBoard)
        thisRef.$router.push('/tasks/taskBoardSettings')
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    editTaskBoardSettingsOnClick (board) {
      this.commonDataTaskBoardForChangeSettingsSet(board)
      this.$router.push('/tasks/taskBoardSettings')
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.el-tabs__item {
  padding-left: 0px;
}
</style>

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 0px;
  background: #fff;
  height: calc(100% - 50px); /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.board-title {
}
.board-title:hover{
  cursor: pointer;
}
.board-edit-icon {
  font-size: 18px;
  color: #fff;
  padding-left: 5px;
}
.board-edit-icon:hover,  .board-title:hover .board-edit-icon{
  color: #ddd;
  cursor: pointer;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// TaskBoards.vue?020fee7c